import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import ConditionalWrapper from '../../../ConditionalWrapper';
import ErrorBoundary from '../../../ErrorBoundary';
import { gallectionTypeToResourceType } from '../../../types/gallection';
import folderCardStyles from '../../FolderCard.scss';
export const FolderCardLayout = ({ folder, className, contentClickBiData, dataHook, content, ribbon, footer, wrapCondition, wrap, isSelected, onClick, width, height })=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FolderCardLayout"
    }, /*#__PURE__*/ React.createElement(Section, {
        className: classnames(folderCardStyles['root'], onClick && folderCardStyles['clickable'], className),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: wrapCondition,
        wrap: wrap
    }, /*#__PURE__*/ React.createElement(BiDiv, {
        className: classnames(folderCardStyles['content'], isSelected && folderCardStyles['selected']),
        onClick: onClick,
        biData: BiData(_object_spread({
            evid: 100,
            page_typeid: BiContextProvidedValue,
            page_itemid: BiContextProvidedValue,
            typeid: gallectionTypeToResourceType(folder.type),
            itemid: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        }, contentClickBiData)),
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['preview-container']
    }, content), ribbon && /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['ribbon-wrapper']
    }, ribbon), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['footer']
    }, footer)))));
};
export default FolderCardLayout;
